/* eslint-disable max-len */
import { createSlice } from '@reduxjs/toolkit';
import { isEmptyObject } from '../../utilities/helperUtilities';
import type { RootState } from '../store';
import {
  fetchActiveSchoolYears ,
} from '../thunks/activeSchoolYearThunks';
import { SelectOption } from '../../types/SelectOption';

const convertLongformSchoolYearToShortform = (schoolYear: string): SelectOption => {
  const years = schoolYear.split('-');
  console.log('years', years);
  console.log('year[1]', years[1]);
    return { value: years[1], text: schoolYear, isDisabled: false};
}
// const convertSchoolYearsToSelectOptions = (schoolYears: string[]): SelectOption[] => {
//   return schoolYears.map((longSchoolYear: string) :SelectOption => {return convertLongformSchoolYearToShortform((longSchoolYear)) });
// }
const convertSchoolYearsToSelectOptions = (schoolYears: string[]): SelectOption[] => {
  return schoolYears.map((longSchoolYear: string) :SelectOption => {return convertLongformSchoolYearToShortform((longSchoolYear)) }).reverse();
}

interface ActiveSchoolYearsState {
  schoolYear: SelectOption;
  schoolYears: SelectOption[];
  loadingSchoolYears: boolean;
}

export const defaultActiveSchoolYearsState: ActiveSchoolYearsState = {
  schoolYear: { value: '', text: '' },
  schoolYears: [],
  loadingSchoolYears: false,
};

export const initialState: ActiveSchoolYearsState = {
  schoolYear: { value: '', text: '' },
  schoolYears: [],
  loadingSchoolYears: false,
};

export const activeSchoolYearsSlice = createSlice({
  name: 'activeSchoolYears',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

    // fetchActiveSchoolYears
    builder.addCase(fetchActiveSchoolYears.pending, (state) => {
      state.schoolYears = [];
      state.loadingSchoolYears = true;
    });
    builder.addCase(fetchActiveSchoolYears.fulfilled, (state, action) => {
      if (!isEmptyObject(action.payload)) {
        state.schoolYears = convertSchoolYearsToSelectOptions(action.payload)
      }
      state.loadingSchoolYears = false;
    });
    builder.addCase(fetchActiveSchoolYears.rejected, (state, action) => {
      if (!action.meta.aborted) {
        state.loadingSchoolYears = false;
      }
    });
  },
});

//export reducers
export const {

} = activeSchoolYearsSlice.actions;

// schoolYears
export const selectActiveSchoolYears = (
  state: RootState
): SelectOption[] => state.activeSchoolYears.schoolYears;

export default activeSchoolYearsSlice.reducer;
